export default __webpack_public_path__ + "371f27bc07e961c0a1a940e436687558.svg";